// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Messages_wrap_3z9cA","modal":"Messages_modal_4VCFr"};